import { render } from "./SendMessageDialog.vue?vue&type=template&id=09781d8e&scoped=true"
import script from "./SendMessageDialog.vue?vue&type=script&lang=js"
export * from "./SendMessageDialog.vue?vue&type=script&lang=js"

import "./SendMessageDialog.vue?vue&type=style&index=0&id=09781d8e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09781d8e"]])

export default __exports__